import { ReactNode } from "react";
import { AddMenu, type AddEntry } from "./AddMenu";
import { AppShell } from "./AppShell";
import { MobileShell, MobileTopBar } from "./MobileShell";
import { NavMenu, type NavEntry } from "./NavMenu";
import { TopBar } from "./TopBar";
import { SkeletonRegion } from "../primitives/Skeleton";

interface ShellSkeletonProps {
  primary: readonly NavEntry[];
  secondary: readonly NavEntry[];
  footer: readonly NavEntry[];
  addEntries: readonly AddEntry[];
  activeId: string | null;
  compact?: boolean;
  children: ReactNode;
}

const inertProps = { inert: "" } as Record<string, string>;

const noop = () => undefined;

export const ShellSkeleton = ({
  primary,
  secondary,
  footer,
  addEntries,
  activeId,
  compact = false,
  children,
}: ShellSkeletonProps) => (
  <SkeletonRegion visible>
    <div className="contents" {...inertProps}>
      {compact ? (
        <MobileShell topBar={<MobileTopBar onMenu={noop} onAdd={noop} />}>{children}</MobileShell>
      ) : (
        <AppShell
          menu={
            <NavMenu
              primary={primary}
              secondary={secondary}
              footer={footer}
              classes={[]}
              loadingClasses
              activeId={activeId}
              activeClassId={null}
              onSelect={noop}
              onSelectClass={noop}
              onAddClass={noop}
            />
          }
          topBar={
            <TopBar
              userName=""
              userInitials=""
              hasNotifications
              onBack={noop}
              addSlot={<AddMenu entries={addEntries} onSelect={noop} />}
            />
          }
        >
          {children}
        </AppShell>
      )}
    </div>
  </SkeletonRegion>
);
